import type { PhoneActionSet } from './phoneActionsContext';

/**
 * A PAGE'S VERBS ON A PHONE STRIP — its one primary, and the secondary that
 * rides beside it ("Continue visit · draft", "Issue ▾").
 *
 * On the desk they live in the top bar. A phone has no top bar, so both the
 * shell's fallback screen and a page's own `PhoneScreen` put them in the
 * strip's trailing slot — drawn by this one component, so the two can never
 * disagree about what the verb looks like or which comes first. The PRIMARY
 * comes first, as every phone board draws it (`maie-phone-doctor/g_f1`).
 */
export function PhoneActions({ primary, secondary }: PhoneActionSet) {
  if (!primary && !secondary) return null;
  return (
    <span className="flex" style={{ gap: 6, flexShrink: 0 }}>
      {primary ? (
        <button type="button" className="chip chip-act chip-brand chip-sm w6"
          onClick={primary.onClick} disabled={primary.disabled}>
          {primary.label}
        </button>
      ) : null}
      {secondary ? (
        <button type="button" className="chip chip-act chip-outline chip-sm"
          onClick={secondary.onClick} disabled={secondary.disabled}>
          {secondary.label}
        </button>
      ) : null}
    </span>
  );
}
